import { Divider, Message, Placeholder } from 'semantic-ui-react';
import UsageInsights from './components/UsageInsights';
import { Company, Plan, ResourcesUsage } from '../../types';
import MessagesTimeSeries from './components/MessagesTimeSeries';
import { useLocale } from '../../hooks';

type Props = {
    loading?: boolean;
    plan: Plan | undefined;
    selectedWabaId: string;
    company: Company | undefined;
    usageMonth: ResourcesUsage;
};

const Insights = (props: Props) => {
    const { selectedWabaId, loading = true, plan, company, usageMonth } = props;

    const labels = useLocale({
        allConversations: 'All conversations',
        date: 'Date',
        company: 'Company',
        approximateCharges: 'Approximate charges',
        freePeriodConversations: 'Free period conversations',
        thisMonthsInsights: "This month's insights",
        messagesRenewalDate: 'Messages Renewal Date',
        noAssociatedPlan: 'No Associated Plan',
        insights: 'Insights',
        plan: 'Plan',
        current: 'Current',
        home: 'Home',
    });

    const getInsetCard = (label: string, icon: string, value: string) => {
        return <Message size='small' icon={icon} header={label} content={value} style={{ margin: 0 }} />;
    };

    const placeholder = (
        <Placeholder style={{ height: '330px', maxWidth: 'unset' }}>
            <Placeholder.Image />
        </Placeholder>
    );

    return (
        <>
            <div style={{ display: 'flex', gap: '10px', margin: '0 0 20px 0' }}>
                {getInsetCard(labels.plan, 'dollar', company?.plan?.plan_name || labels.noAssociatedPlan)}
                {getInsetCard(
                    labels.messagesRenewalDate,
                    'redo',
                    (company?.company_plan_expiration_date &&
                        new Date(company?.company_plan_expiration_date).toLocaleDateString('pt')) ||
                        'Sem data de expiração',
                )}
            </div>

            <UsageInsights loading={loading} plan={plan} company={company} usageMonth={usageMonth} />
            <Divider section />
            {(!loading && <MessagesTimeSeries selectedWabaId={selectedWabaId} />) || <>{placeholder}</>}
        </>
    );
};

export default Insights;
